import {
    List,
    Datagrid,
    TextField,
    Show,
    SimpleShowLayout,
    ShowButton,
    EditButton,
    BulkDeleteButton,
} from "react-admin";

import PrevPagination from "../core/PrevPagination";

export const ClientList = (props) => {
    return (
        <List {...props} bulkActionButtons={false} pagination={<PrevPagination />}>
            <Datagrid bulkActionButtons={false}>
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="parentClientId" label="Parent Client Id" />
                <TextField source="emailDomainNames" label="Email Domain" />
                <TextField source="lastModifiedDttm" label="Last Modified Dttm" />
                <TextField source="lastModifiedUser" label="Last Modified User" />
                <TextField source="version_id" label="Version Id" />
                <ShowButton />
                <EditButton />
                <BulkDeleteButton mutationMode="pessimistic" />
            </Datagrid>
        </List>
    );
};

export const ClientShow = (props) => {
    return (
        <Show title="View Client" {...props}>
            <SimpleShowLayout>
                <TextField source="id" label="Client Id" />
                <TextField source="name" />
                <TextField source="parentClientId" label="Parent Client Id" />
                <TextField source="emailDomainNames" label="Email Domain" />
                <TextField source="lastModifiedDttm" label="Last Modified Dttm" />
                <TextField source="lastModifiedUser" label="Last Modified User" />
                <TextField source="version_id" label="Version Id" />
            </SimpleShowLayout>
        </Show>
    );
};
